import {css} from '../../../theme/css'
import {breakpoints, spacing} from '../../../theme/theme'

export const classes = {
  container: css`
    margin-inline: ${spacing(1.5)};
  `,
  iconWrap: css`
    inline-size: ${spacing(3)};
    block-size: ${spacing(3)};
    transform: translate(-50%, -50%);

    ${breakpoints.down('sm')} {
      inline-size: ${spacing(3)};
      block-size: ${spacing(3)};
    }
  `,
  tooltip: css`
    z-index: 15 !important;
    inline-size: max-content;

    ${breakpoints.down('sm')} {
      display: none;
    }
  `,
}
